/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/
/**
 * author: tman
 */
import React from 'react';
import PropTypes from 'prop-types';
import {Panel,Button } from 'react-bootstrap';
import AOForm from '../../../../shared/AOForm';
import Info from "../Info/index";

const PanelGroupReview = (props) => {
    const {
        content,
        className,
        handelHead,
        handelSkipUpload,
        disabled,
        isSkipUpload,
        dummy
    } = props;
    const editClass= content.isDisable ? 'review-disable' : '';
    const completeClass = content.state === 2 ? 'btn-info': '';
    const isBtnDisplay = content.state === 1 ? true : content.isPanel ? false  : true;
    return (
        <div className={`review-panel-group ${className} ${editClass}`}>
            <AOForm.ContentOnly
                content={content.contentOnly}
            />
            <Info
                content={content.info}
            />
            
            {
                content.panelHeadButton && 
                !content.isDisable && 
                isBtnDisplay && 
                <div>
                    {
                        dummy && isSkipUpload && content.msgBox && content.state !== 2 && 
                        <AOForm.MsgBox
                            content={content.msgBox}
                            type="warning"
                        />
                    }
                    <Button aria-expanded={content.state === 2 ?'false':'undefined'}
                        disabled={disabled}
                        className={`review-panel-button ${completeClass}`} 
                        onClick={(event) => handelHead(event, content.state)} 
                        data-key={ content.panelHeadButton.dataKey }
                        data-eventtag={ content.panelHeadButton.dataEvent } 
                        bsStyle="primary" >
                        {content.panelHeadButton.text}
                    </Button>
                    {
                        dummy && isSkipUpload && className !== 'determine' && content.state !== 2 &&
                        <Button 
                            className="skip-upload-botton" 
                            onClick={(event) => handelSkipUpload(event)} 
                            data-key={ content.skipButton.dataKey} 
                            bsStyle="primary" >
                            {content.skipButton.text}
                        </Button>
                    }
                </div>
                
            }
            
            {
                /*
                * expanded=false :Panel expanded
                * */
                className !== 'determine' &&
                <Panel  expanded={content.isPanel} defaultExpanded={content.isPanel} collapsible className="panel-item-body">
                    {!content.isDisable && props.children }

                    {
                       /*
                       *
                       * WAI-ARIA Web Accessibility Specification:
                       *    aria-expanded :Expanded state. undefined=state is unknown,
                       *    true=expanded,false=not expanded
                       *
                       * */
                        content.panelBodyButton && 
                        content.state === 2 && 
                        <Button aria-expanded="true" className="btn-info review-body-button"
                            disabled={disabled}
                            onClick={event => handelHead(event, content.state)} 
                            data-key={content.panelBodyButton.dataKey}
                            data-eventtag={ content.panelBodyButton.dataEvent }  
                            bsStyle="primary">
                        {content.panelBodyButton.text}
                        </Button>
                    }
                </Panel>

            }

        </div>
    )
};

PanelGroupReview.propTypes = {
    content: PropTypes.object.isRequired,
    className:PropTypes.string,
    handelHead:PropTypes.func,
    handelSkipUpload: PropTypes.func,
    index:PropTypes.number,
    disabled: PropTypes.bool
};
PanelGroupReview.defaultProps = {
    content: {},
    className:'',
    disabled: false,
    isSkipUpload: false
};

export default PanelGroupReview;



// WEBPACK FOOTER //
// ./src/views/AOFormReview/components/PanelGroupReview/index.js